import { BugReportOutlined, Close } from '@mui/icons-material';
import { Box, IconButton, styled } from '@mui/material';
import type { Theme } from '@mui/material/styles';

function queryDevtoolsIconStyles({ theme }: { theme: Theme }) {
  return {
    flexShrink: 0,
    opacity: 0,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
    }),
    '@media (prefers-reduced-motion: reduce)': {
      transition: 'none',
    },
  };
}

export const QueryDevtoolsPanelContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: theme.zIndex.globalError,
  height: 'clamp(360px, 45dvh, 640px)',
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[16],
  [theme.breakpoints.down('sm')]: {
    height: '60dvh',
  },
}));

export const QueryDevtoolsTrigger = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  top: '50%',
  right: 0,
  zIndex: theme.zIndex.globalError + 1,
  width: 48,
  height: 48,
  padding: 0,
  transform: 'translateY(-50%)',
  borderRadius: 0,
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '&:hover .query-devtools-bookmark, &.Mui-focusVisible .query-devtools-bookmark': {
    width: 40,
  },
  '&:hover .query-devtools-icon, &.Mui-focusVisible .query-devtools-icon': {
    opacity: 1,
  },
}));

export const QueryDevtoolsBookmark = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  display: 'flex',
  width: 12,
  height: 48,
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  color: theme.palette.error.contrastText,
  backgroundColor: theme.palette.error.main,
  borderRadius: `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`,
  boxShadow: theme.shadows[4],
  transition: theme.transitions.create('width', {
    duration: theme.transitions.duration.shorter,
  }),
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
}));

export const QueryDevtoolsIcon = styled(BugReportOutlined)(queryDevtoolsIconStyles);

export const QueryDevtoolsCloseIcon = styled(Close)(queryDevtoolsIconStyles);
